import React from 'react';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import FeatureTitle from '../../components/feature-title/feature-title';
import Profile from '../../components/profile/profile';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Services
import StorageService from '../../services/storage-service';

const ShowProfile = () => {
  const storageService = new StorageService();
  const employee = storageService.getEmployee();

  // Logging out clears the stored employee and re-renders this page once more before the route leaves it.
  if (!employee) {
    return null;
  }

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='together' sideAlign='left'>
        <FeatureTitle title='configurações do perfil' />
      </ButtonsBar>
      <Profile employee={employee} />
    </BaseContentContainer>
  );
};

export default ShowProfile;
